import { normalize } from 'normalizr'
import { call, put, all, takeLatest, takeEvery } from 'redux-saga/effects'
import apiClient from 'services/axios'
import ApiConfig from 'services/config'
import pagaSaga from 'redux/pagination/sagas'
import actions from './actions'
import {
  updateEntities,
  customerEntity,
  earningHistoryEntity,
  redemptionHistoryEntity,
  giftHistoryEntity,
  commHistoryEntity,
} from '../entities'

function* fetchCustomerDetail({ payload }) {
  const { id, code } = payload
  yield put({ type: actions.DETAIL_FETCHING })
  try {
    // const { reward, promotion } = yield all({
    const { reward } = yield all({
      reward: call(
        apiClient.get,
        `${ApiConfig.CustomerConfig.AVAILABLE_REWARDS.replace(':id', id)}${code}`,
      ),
      // promotion: call(
      //   apiClient.get,
      //   `${ApiConfig.CustomerConfig.ELIGIBLE_PROMOTIONS.replace(':id', id)}${code}`,
      // ),
    })
    const customer = {
      _id: id,
      availableRewards: reward?.data?.rewards ?? [],
      // eligiblePromotions: promotion?.data?.promotions ?? [],
    }
    const { entities, result } = normalize(customer, customerEntity)
    yield put(updateEntities(entities))
    yield put({ type: actions.DETAIL_FULFILLED, payload: result })
  } catch (err) {
    // handle error
    console.log(err)
    yield put({ type: actions.DETAIL_REJECTED })
  }
}

function* updateCustomer({ payload = {} }) {
  const { customer = {} } = payload
  const { entities } = normalize({ ...customer }, customerEntity)
  yield put(updateEntities(entities))
}

const norm = data => normalize(data?.customers ?? [], [customerEntity])
const normEarning = data => normalize(data?.points ?? [], [earningHistoryEntity])
const normRemdemption = data => normalize(data?.reward_redeem ?? [], [redemptionHistoryEntity])
const normCommunication = data => normalize(data?.communications ?? [], [commHistoryEntity])
const normGift = data => normalize(data?.customer_gifts ?? [], [giftHistoryEntity])

export default function* rootSaga() {
  yield all([
    takeLatest(actions.DETAIL, fetchCustomerDetail),
    takeEvery(actions.UPDATE, updateCustomer),
    // customers
    ...pagaSaga([actions.LIST, actions.LIST_NEXT], norm),
    // earning history
    ...pagaSaga([actions.LIST_EARNING, actions.LIST_EARNING_NEXT], normEarning),
    // redemption history
    ...pagaSaga([actions.LIST_REDEMPTION, actions.LIST_REDEMPTION_NEXT], normRemdemption),
    // communication history
    ...pagaSaga([actions.LIST_COMMUNICATION, actions.LIST_COMMUNICATION_NEXT], normCommunication),
    // gift history
    ...pagaSaga([actions.LIST_GIFT, actions.LIST_GIFT_NEXT], normGift),
  ])
}
